var exports = {
  "k": "x93eb46d8--c0f048--container",
  "j": "x93eb46d8--c0f048--spacer",
};

module.exports = exports;
